module.exports = __webpack_public_path__ + "static/media/board_64.36746ace.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/board_64.svg
// module id = 685
// module chunks = 0